var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-overlay',{attrs:{"show":_vm.isLoading}},[_c('div',[(_vm.prebecario && _vm.listDocuments)?_c('prebecario',{attrs:{"data":_vm.prebecario,"list-documents":_vm.listDocuments,"mode":_vm.mode}}):_vm._e()],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }